const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/zgks/eCheckin/constants.ts';
export const SECTION_PATH_PERS_ANGABEN = 'persAngaben';
export const SECTION_PATH_HAUSARZT = 'hausArzt';
export const SECTION_PATH_EINWARZT = 'einwArzt';
export const SECTION_PATH_KONTAKT = 'kontakt';